import { render, staticRenderFns } from "./SendNotificationModal.vue?vue&type=template&id=0b720214&scoped=true&"
import script from "./SendNotificationModal.vue?vue&type=script&lang=ts&"
export * from "./SendNotificationModal.vue?vue&type=script&lang=ts&"
import style0 from "./SendNotificationModal.vue?vue&type=style&index=0&id=0b720214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b720214",
  null
  
)

export default component.exports